import { TextField } from '@material-ui/core';

import React from 'react';

const SmileInput = ({ type, label,key, value, required, onChange, showError }) => {

  return (
    <TextField
      id={label}
      data-testid={`form${key}`}
      type={type}
      label={label}
      required={required}
      value={value}
      onChange={onChange}
      variant="outlined"
      size="small"
      error={showError}
      fullWidth
    />
  );
};

export default SmileInput;